import '../../sass/plugins/experienced_professionals_carousel.scss';

$(() => {
  const experiencedProfessionalsCarousels = $(
    '.experienced-professionals-carousel'
  );

  const initializeExperiencedProfessionalsCarousels = (element) => {
    const sliderNavigation = $(element).find(
      '.experienced-professionals-carousel__navigation'
    );
    const sliderPersonDetails = $(element).find(
      '.experienced-professionals-carousel__person-details'
    );
    const sliderImage = $(element).find(
      '.experienced-professionals-carousel__image'
    );
    const nextArrow = $(element).find('.next');
    const prevArrow = $(element).find('.prev');

    sliderNavigation.slick({
      infinite: true,
      variableWidth: true,
      dots: true,
      appendDots: '.experienced-professionals-carousel__dots',
      mobileFirst: true,
      slidesToShow: 1,
      swipe: false,
      nextArrow,
      prevArrow,
      focusOnSelect: true,
      asNavFor:
        '.experienced-professionals-carousel__person-details, .experienced-professionals-carousel__image',
    });

    sliderPersonDetails.slick({
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      fade: true,
      swipe: false,
      mobileFirst: true,
    });

    sliderImage.slick({
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      fade: true,
      swipe: false,
      mobileFirst: true,
    });
  };

  experiencedProfessionalsCarousels.each((_, element) =>
    initializeExperiencedProfessionalsCarousels(element)
  );
});
